export function validateOcrFile(file) {
  if (!file) return '파일을 선택하거나 캡처 이미지를 붙여넣어 주세요.';
  const ext = file.name?.split('.').pop()?.toLowerCase();
  if (!['png', 'jpg', 'jpeg', 'pdf'].includes(ext)) return 'PNG·JPG·JPEG 이미지 또는 PDF를 올려 주세요.';
  if (file.size === 0) return '비어 있는 파일입니다. 다시 선택해 주세요.';
  if (ext !== 'pdf' && file.size > 20 * 1024 * 1024) return '이미지는 20MB 이하로 올려 주세요.';
  return null;
}

// paste 이벤트의 이미지만 사용한다. 텍스트 붙여넣기는 가로채지 않고 클립보드 권한도 요청하지 않는다.
export function clipboardOcrImage(clipboardData) {
  const items = Array.from(clipboardData?.items || []).filter((item) => item.kind === 'file' && item.type.startsWith('image/'));
  const files = items.length ? items.map((item) => item.getAsFile()).filter(Boolean)
    : Array.from(clipboardData?.files || []).filter((file) => file.type.startsWith('image/'));
  if (!files.length) return null;
  if (files.length !== 1) return { error: '캡처 이미지는 한 장씩 붙여넣어 주세요.' };
  const file = files[0];
  if (!['image/png', 'image/jpeg'].includes(file.type)) return { error: 'PNG 또는 JPG 캡처 이미지를 붙여넣어 주세요.' };
  const ext = file.type === 'image/jpeg' ? 'jpg' : 'png';
  const named = new File([file], `캡처-${Date.now()}.${ext}`, { type: file.type });
  return { file: named, error: validateOcrFile(named) };
}

export const validBbox = (box) => Array.isArray(box) && box.length === 4 && box.every((v) => typeof v === 'number' && Number.isFinite(v) && v >= 0 && v <= 1)
  && box[2] > box[0] && box[3] > box[1];
const clamp = (n) => Math.max(0, Math.min(1, n));
export function imagePoint(event, rect) {
  return [clamp((event.clientX - rect.left) / rect.width), clamp((event.clientY - rect.top) / rect.height)];
}
export function dragBbox(start, point, original, handle) {
  if (handle === 'move' && validBbox(original)) {
    const dx = Math.max(-original[0], Math.min(1 - original[2], point[0] - start[0]));
    const dy = Math.max(-original[1], Math.min(1 - original[3], point[1] - start[1]));
    return [original[0] + dx, original[1] + dy, original[2] + dx, original[3] + dy];
  }
  const anchor = handle && validBbox(original)
    ? [handle.includes('w') ? original[2] : original[0], handle.includes('n') ? original[3] : original[1]] : start;
  return [Math.min(anchor[0], point[0]), Math.min(anchor[1], point[1]), Math.max(anchor[0], point[0]), Math.max(anchor[1], point[1])];
}
